import { StyleSheet, TouchableOpacity } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons"
import * as Colors from "../styles/colors"

export default function ButtonIcon({ onPress, iconName, colorButton, size = 32, style }) {
    return <TouchableOpacity style={[styles.icon, { backgroundColor: colorButton }, style]} onPress={() => onPress()}>
        <Icon name={iconName} size={size} color={Colors.WHITE} />
    </TouchableOpacity>
}

const styles = StyleSheet.create({
    icon: {
        padding: 8,
        borderRadius: 8,
        shadowColor: Colors.GRAY_DARK,
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
    }
})